import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { RadioContainer } from 'components/Radio';
import { Radio } from 'antd';

const RadioAutoLoanList = props => {
  const { handleAccountRadioClick, refinanceAccount, autoLoanAccounts } = props;
  return (
    <RadioContainer
      className="radioAutoLoanList"
      onChange={handleAccountRadioClick}
      value={parseInt(refinanceAccount)}
    >
      <FlexContainer className="flex-column">
        {autoLoanAccounts.map((item, index) => {
          return (
            <div className="padB24">
              <Radio
                key={item.idHash}
                value={index + 1}
                className="brand-radio"
              >
                <span className="text-16">{item.name}</span>
              </Radio>
            </div>
          );
        })}
      </FlexContainer>
    </RadioContainer>
  );
};

export default RadioAutoLoanList;
